import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { emitTelemetry, normalizeError } from '@/observability';

function operationName(key: readonly unknown[] | undefined): string {
  return typeof key?.[0] === 'string' ? key[0] : 'unknown';
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      emitTelemetry('frontend.mutation.error', {
        operation: operationName(mutation.options.mutationKey),
        ...normalizeError(error),
      });
    },
  }),
  queryCache: new QueryCache({
    onError: (error, query) => {
      emitTelemetry('frontend.query.error', {
        operation: operationName(query.queryKey),
        ...normalizeError(error),
      });
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});
